import Axios, { AxiosInstance } from 'axios';

import { API_URL } from './config';

export const setAxiosOnError = (handler: (error: any) => void) => {
  axiosOnError = handler;
};

let axiosOnError: (error: any) => void;

const buildHttpClient = ({ baseUrl = '' }): AxiosInstance => {
  const httpClient = Axios.create({
    baseURL: baseUrl,
    withCredentials: true
  });

  httpClient.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status !== 401) {
        if (axiosOnError && !error.config?.skipGlobalErrorHandler) {
          axiosOnError(error);
        }
      } else {
        const isOnLoginPage = window.location.pathname === '/login';
        const isAuthUserRequest = error?.request?.responseURL?.indexOf('/auth/user') >= 0;
        const isOnUpdateRequirementsPage = window.location.pathname.startsWith('/update-requirements');
        const isOnUpdateLoyaltyPage = window.location.pathname.startsWith('/update-loyalty');
        const isOnContractSignPage = window.location.pathname.startsWith('/contract-sign');
        if (
          !isOnLoginPage &&
          !isAuthUserRequest &&
          !isOnUpdateRequirementsPage &&
          !isOnUpdateLoyaltyPage &&
          !isOnContractSignPage
        ) {
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );

  return httpClient;
};

const mainDbAxiosClient = buildHttpClient({ baseUrl: API_URL });

export const getAxios = () => {
  return mainDbAxiosClient;
};
